<template>
<!-- 상태 변경 팝업 -->
<transition name="modal" appear>
    <div class="modal modal-overlay">
        <div class="modal-dialog modal-dialog-centered" role="document">
            <div class="modal-content">
                <div class="modal-body">
                    <div>
                        <p class="bold dp-inblock h-30px font-23 mb-30">{{name}}님 결제 내역</p>
                        <a class="pointer float-right layer-close ml-30" @click="$emit('close')" data-dismiss="modal" aria-label="Close">
                            <img src="../../assets/img/close.png" alt="close" class="close-btn">
                        </a>
                        <div class="apply-fieldset">
                            <div class="hq-table-row">
                                <h3>결제 정보</h3>
                                <table>
                                    <colgroup>
                                        <col style="width:30%">
                                        <col style="width:70%">
                                    </colgroup>
                                    <tbody>
                                        <div style="width: 430px" class="mb-20" v-for="(item, index) of viewPay" :key="index">
                                            <tr>
                                                <th style="min-width:120px">과정명</th>
                                                <td style="width:100%">{{item.subject_name}}</td>
                                            </tr>
                                            <tr>
                                                <th>교육비</th>
                                                <td>
                                                    {{numberFormat(item.edu_price) || '-'}} 원
                                                </td>
                                            </tr>
                                            <tr>
                                                <th>교재비</th>
                                                <td>
                                                    {{numberFormat(item.book_price) || '-'}} 원
                                                </td>
                                            </tr>
                                        </div>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="modal-footer txt-center h-100px" style="display: block">
                    <div class="h-50px">
                        <div class="flot-left strong">
                            총 결제금액
                        </div>
                        <div class="float-right strong">
                            {{numberFormat(totalPrice) || '-'}} 원
                        </div>
                    </div>
                    <div>
                        <div>
                            <a class="pointer admin-btn-default btn ml-05 w-100px" @click="$emit('close')">확인</a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</transition>
</template>

<script>
export default {
    props: ['parentPay'],
    data: () => ({
        isModalOpened: false,

        name: '', // 상태 변경할 수강자 이름

        useWait: false, // 대기 상태 사용여부
        usePay: false, // 결제 상태 사용여부
        useAlt: 'N', // 알림톡 발송 사용여부
        altYn: 'N',

        status: '', // 대기전체 '', 대기 Y, 신청완료 N, 신청취소 C
        payStatus: '', // '' 전체, Y 결제완료 N 미결제, C 결제없음
        studentSubjectIdx: '', // 보낼 수강자의 고유 idx
        totalPrice: 0,

        smsText: '', // sms문구

        payData: {},
        viewPay: [] // 결제 정보 리스트
    }),

    mounted() {
        this.payData = this.parentPay
        this.name = this.payData.name
        this.studentSubjectIdx = this.payData.idx_itm_sugang_student_subject

        var params = {
            studentSubjectIdx: this.studentSubjectIdx
        }

        this.axios.get(this.axios.root + this.axios.port + '/admin/sugang-user-pay', {
            params: params
        }).then(res => {
            console.log('res', res)
            if (res.data.err === 0) {
                this.viewPay = res.data.viewPay
                for (var item of this.viewPay) {
                    if (item.partial_pay === 'A') {
                        if (item.edu_price && item.edu_price !== '') {
                            this.totalPrice += item.edu_price
                        }
                        if (item.book_price && item.book_price !== '') {
                            this.totalPrice += item.book_price
                        }
                    } else if (item.partial_pay === 'B') {
                        // if (item.book_price && item.book_price !== '') {
                            this.totalPrice += item.book_price
                        // }
                    } else if (item.partial_pay === 'C') {
                        // if (item.edu_price && item.edu_price !== '') {
                            this.totalPrice += item.edu_price
                        // }
                    }
                    console.log('this.totalPrice', this.totalPrice)
                }
            } else {

            }
        }).catch(err => {
            console.log(err)
        })
        console.log('this.payData', this.payData)
    },

    methods: {
        // 숫자 1000 단위로 콤마찍기 (1000 => 1,000)
        numberFormat(inputNumber) {
            console.log(inputNumber, inputNumber)
            if (inputNumber) {
                return inputNumber.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
            } else {
                return '-'
            }

        },

        // 자식 모달에서 SMS 문구 받아옴
        applySMSText(text) {
            this.isModalOpened = false
            this.smsText = text
        }
    }
}
</script>

<style lang="scss" scoped>
.modal {
    &.modal-overlay {
        display: flex;
        align-items: center;
        justify-content: center;
        position: fixed;
        z-index: 30;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.5);
    }

    &-window {
        background: #fff;
        border-radius: 4px;
        overflow: hidden;
    }

    &-content {
        padding: 10px 20px;
    }

    &-footer {
        // background: #ccc;
        padding: 10px;
        text-align: right;
    }
}

.modal-enter-active,
.modal-leave-active {
    transition: opacity 0.4s;

    .modal-window {
        transition: opacity 0.4s, transform 0.4s;
    }
}

.modal-leave-active {
    transition: opacity 0.6s ease 0.4s;
}

.modal-enter,
.modal-leave-to {
    opacity: 0;

    .modal-window {
        opacity: 0;
        transform: translateY(-20px);
    }
}
</style>
